import {
    ADD_SKILLS_REQUEST,
    ADD_SKILLS_SUCCESS,
    ADD_SKILLS_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const AddSkillsAction = (data) => {
    return function (dispatch) {
      
      dispatch({
        type: ADD_SKILLS_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_skills`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
      return axios(OPTION)
        .then((res) => {
          dispatch(CreateJobFormPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: ADD_SKILLS_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(error.msg);
        });
    };
  };
  
  export const CreateJobFormPre = (data) => {
  toast.success("Skills added successfully.");
    return {
      type: ADD_SKILLS_SUCCESS,
      createJob: data.status.message,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };

